export default "__VITE_ASSET__Bc$xMTvo__"